import { appScreen, Draw, Image, useVoucherStore } from '@slot-nx/core'
import { Container, Graphics } from '@pixi/react'
import { VoucherSelectPopupTitle } from './VoucherSelectPopupTitle'
import { VoucherSelectPopupContent } from './VoucherSelectPopupContent'
import { VoucherSelectPopupTime } from './VoucherSelectPopupTime'
import { VoucherSelectPopupButtons } from './VoucherSelectPopupButtons'
import { memo, useCallback, useEffect, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import gsap from 'gsap'
import { VoucherSoundType } from '@slot-nx/core'
import { sound } from '@pixi/sound'

export function showPopupAnimation(popupRef: PixiContainer) {
  gsap.set(popupRef, { alpha: 0, scale: 0.8 })
  gsap.to(popupRef.scale, {
    x: 1,
    y: 1,
    ease: 'back.out(1.7)',
    duration: 0.5,
  })
  gsap.to(popupRef, {
    alpha: 1,
    duration: 0.5,
  })
}

export const VoucherSelectPopup = memo(() => {
  const [isShowVoucherPopup, remainSpin, expireDate] = useVoucherStore(x => [x.isShowVoucherSelectPopup, x.remainSpin, x.expireDate])
  const popupRef = useRef<PixiContainer>()

  useEffect(() => {
    if (isShowVoucherPopup && popupRef.current) {
      sound.play(VoucherSoundType.selectPopup)
      showPopupAnimation(popupRef.current)
    }
  }, [isShowVoucherPopup])

  const maskDraw = useCallback<Draw>((g) => {
    g.clear()
    g.beginFill('black', 0.8)
    g.drawRect(0, 0, appScreen.width, appScreen.height)
    g.endFill()
  }, [])

  return (
    <Container name="VoucherSelectPopupWrapper" visible={isShowVoucherPopup}>
      <Graphics draw={maskDraw} eventMode="static" />
      <Container name="VoucherPopup_Bg">
        <Container x={540} y={960} name="VoucherSelectPopup" ref={(el) => { popupRef.current = el as PixiContainer }}>
          <Image name="voucher_popup" image="voucher_Pop-up" width={942} height={1344} anchor={[0.5, 0.5]} x={0} y={0} />
          <VoucherSelectPopupTitle totalRounds={remainSpin} />
          <VoucherSelectPopupContent />
          <VoucherSelectPopupTime expireTime={expireDate} />
          <VoucherSelectPopupButtons />
        </Container>
      </Container>
    </Container>
  )
})
